export const ANCHORDATACATEGORIES = [
  "finance",
  "ops",
  "qm",
  "vertrieb",
];
// virtual tab value: filtered view, not a backend category — must never be
// sent as `category` (the backend enum has no such value)
export const ANCHORDATA_VIRTUAL_CATEGORY_MISSING_REQUIRED = "missing_required";
export const ANCHORDATASUBCATEGORIES = [
  "allgemein",
  "vertrag",
  "preis",
  "kundenstatus",
];
